import { useEffect, useState } from "react";

import { ConfigService } from "../../config/ConfigService";

/**
 * True when the Xero module is installed for this customer, i.e. the config api
 * returns any `xero` rows. `undefined` while loading.
 *
 * Failures resolve to `false` and only log: this runs on every page carrying a
 * Xero push button, so a config blip must not spray snackbars.
 */
export function useXeroModuleInstalled() {
  const [installed, setInstalled] = useState<boolean>();

  useEffect(() => {
    let active = true;

    ConfigService.query("xero")
      .then((cfg) => {
        if (active) {
          setInstalled(Object.keys(cfg).length > 0);
        }
      })
      .catch((e) => {
        console.debug("Xero module config unavailable: ", e);
        if (active) {
          setInstalled(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return installed;
}
